const pad = (value: number, length: number): string => {
    return value.toString().padStart(length, '0');
};

const getFormattedDateParts = (date: Date): {
    day: string;
    month: string;
    year: string;
    hours: string;
    minutes: string;
    seconds: string;
    milliseconds: string;
} => ({
    day: pad(date.getUTCDate(), 2),
    month: pad(date.getUTCMonth() + 1, 2),
    year: pad(Number(date.getUTCFullYear().toString().slice(-2)), 2),
    hours: pad(date.getUTCHours(), 2),
    minutes: pad(date.getUTCMinutes(), 2),
    seconds: pad(date.getUTCSeconds(), 2),
    milliseconds: pad(date.getUTCMilliseconds(), 3),
});

const getCompactTimestamp = (date: Date = new Date()): string => {
  const { day, month, year, hours, minutes, seconds, milliseconds } = getFormattedDateParts(date);
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${day}${month}${year}_${hours}${minutes}${seconds}${milliseconds}_${random}`;
};

export const DateUtils = {
    getCompactTimestamp,
};